import React, { PureComponent, Component } from 'react';
import PropTypes from 'prop-types';
import { Select, message } from 'antd';
import { callApi } from 'utils';
import './index.less';

const SelectOption = Select.Option;
const defaultCodeList = [{
	code: 86,
	name: '中国'
}];

class RegionCode extends (PureComponent || Component) {
	state = {
		regionCode: 86,
		regionCodeList: [],
		// 当前域空间是否支持境外手机号注册
		isSupportOverseasPhone: 0,
	}

	componentDidMount () {
		const { namespaceId } = this.props;
		if (namespaceId || namespaceId === 0) {
			this.listAllRegionCodes(namespaceId);
		}
	}

	componentWillReceiveProps (nextProps) {
		if (nextProps.namespaceId !== this.props.namespaceId) {
			this.listAllRegionCodes(nextProps.namespaceId);
		}
	}

	listAllRegionCodes = (namespaceId) => {
		const { hasDefault = true, onChange } = this.props;
		callApi({
			prefix: '/evh',
			api: '/region/listAllRegionCodes',
			data: { namespaceId },
			success: (response = {}) => {
				const { regionCodeDTOS = [], isSupportOverseasPhone = 0 } = response,
					regionCodeList = hasDefault && regionCodeDTOS.length === 0 ? defaultCodeList : regionCodeDTOS,
					regionCode = hasDefault ? 86 : null;

				onChange && onChange({ regionCode, isSupportOverseasPhone });

				this.setState({
					regionCodeList,
					regionCode
				});
			},
			error: ({ errorDescription = '' }) => {
				message.error(errorDescription);
				onChange && onChange({ regionCode: null, isSupportOverseasPhone: 0 });
				this.setState({
					regionCodeList: [],
					regionCode: null
				});
			}
		});
	}

	// 区域切换
	onChange = (value) => {
		const { onChange } = this.props;
		const { isSupportOverseasPhone } = this.state;
		this.setState({ regionCode: value });
		onChange && onChange({ regionCode: value, isSupportOverseasPhone });
	}

	render () {
		const prefixCls = 'eh-region-code';
		const { regionCodeList, regionCode } = this.state;
		const { className = '', onChange, hasDefault, ...rest } = this.props;

		return (
			<Select
				className={`${prefixCls} ${className}`}
				value={regionCode}
				onChange={this.onChange}
				showSearch
				dropdownMatchSelectWidth={false}
				optionLabelProp='label'
				{...rest}
			>
				{
					regionCodeList.map((item, index) => (
						<SelectOption
						  key={index}
						  value={item.code}
							label={`+ ${item.code}`}
						>
						  {`${item.name} +${item.code}`}
						</SelectOption>
					))
				}
			</Select>
		);
	}
}

RegionCode.propTypes = {
	// 是否展示默认区域
	hasDefault: PropTypes.bool,
	// 选择区域后的回调
	onChange: PropTypes.func,
	// 类名
	className: PropTypes.string
};

RegionCode.defaultProps = {
	hasDefault: true,
	className: ''
};

export default RegionCode;
